interface Props {
  name: string;
  fromLabel: string;
  toLabel: string;
}

export function DragBanner({ name, fromLabel, toLabel }: Props) {
  return (
    <div className="dnd-banner" role="status" aria-live="polite">
      <span>moving</span>
      <span className="name">{name}</span>
      <span className="from">{fromLabel}</span>
      <span className="arrow">→</span>
      <span className="to">{toLabel}</span>
    </div>
  );
}
